console.log("operation/operation_flash : start loading");

// export default class OperationFlash {
//   constructor() {
//     // set close feature to existing flash message
//     const el_parent = document.querySelector("div.flashes");
//     const el_children = Array.from(el_parent.children) as HTMLDivElement[];
//     el_children.forEach((el) => {
//       if (el.classList.contains("flash")) {
//         const el_close = el.querySelector("div.right") as HTMLDivElement;
//         console.log("close=", el_close);
//         if (el_close) {
//           el_close.onclick = (ev) => {
//             el_parent.removeChild(el);
//           };
//         }
//       }
//     });
//   }

//   static flash(level: string, message: string): void {
//     const el_parent = document.querySelector("div.flashes");
//     const el_flash = document.createElement("div");
//     el_parent.appendChild(el_flash);
//     el_flash.classList.add("flash");
//     el_flash.classList.add(level);

//     // render message
//     el_flash.innerHTML = `<div class="left"></div><div class="center">${message}</div><div class="right">閉じる</div>`;

//     const el_close = el_flash.querySelector("div.right") as HTMLDivElement;
//     console.log("close=", el_close);
//     if (el_close) {
//       el_close.onclick = (ev) => {
//         el_parent.removeChild(el_flash);
//       };
//     }
//   }
// }

// // Add flash method to the window instance so that it can be called globally.

// set close feature to existing flash message
const el_parent = document.querySelector("div.flashes");
const el_children = Array.from(el_parent.children) as HTMLDivElement[];
el_children.forEach((el) => {
  if (el.classList.contains("flash")) {
    const el_close = el.querySelector("div.right") as HTMLDivElement;
    console.log("close=", el_close);
    if (el_close) {
      el_close.onclick = (ev) => {
        el_parent.removeChild(el);
      };
    }
  }
});

// const operationFlash = new OperationFlash();
window.operationFlash = function (level: string, message: string): void {
  const el_parent = document.querySelector("div.flashes");
  const el_flash = document.createElement("div");
  el_parent.appendChild(el_flash);
  el_flash.classList.add("flash");
  el_flash.classList.add(level);

  // render message
  el_flash.innerHTML = `<div class="left"></div><div class="center">${message}</div><div class="right"><span class="material-icons">close</span></div>`;

  const el_close = el_flash.querySelector("div.right") as HTMLDivElement;
  console.log("close=", el_close);
  if (el_close) {
    el_close.onclick = (ev) => {
      el_parent.removeChild(el_flash);
    };
  }
};
